import { render, staticRenderFns } from "./BrokerSelect.vue?vue&type=template&id=40560fab&scoped=true&"
import script from "./BrokerSelect.vue?vue&type=script&lang=js&"
export * from "./BrokerSelect.vue?vue&type=script&lang=js&"
import style0 from "./BrokerSelect.vue?vue&type=style&index=0&id=40560fab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40560fab",
  null
  
)

export default component.exports